export default {
	title: "Skriv inn passordet til oppgaven",
	beskrivelse:
		"Oppgavene er passordbeskyttet på grunn av opphavsrett. De er ikke hemmelige for elevene. Skoler og privatistkontor har fått tilsendt passord.",
	passord: "Skriv inn ditt passord",
	submitKnapp: "Ok",
	feilPassord: "Feil passord - vennligst prøv igjen",
	passordRequired: "Passord er påkrevd",
	videresenderTilOppgaven: "Videresender deg til oppgaven"
};
